import { useCallback, useMemo } from 'react'

const useContactsFiltersBar = ({ query, isLoading, onSearch }) => {
  const trimmedQuery = useMemo(() => String(query || '').trim(), [query])

  const canSearch = useMemo(
    () => trimmedQuery.length > 2 && !isLoading,
    [trimmedQuery, isLoading],
  )

  const handleKeyDown = useCallback(
    event => {
      if (event.key === 'Enter' && canSearch) onSearch()
    },
    [canSearch, onSearch],
  )

  return { canSearch, handleKeyDown }
}

export default useContactsFiltersBar
